import { useState } from 'react';
import Grid from '@mui/material/Grid';
import { Stack } from '@mui/material';

import { useDrawerFilter } from '@hapvida/hapvida-core-components';

import { useFilterParams } from '@hooks';
import { SubHeader } from '@components';
import NewSearchField from 'components/filters/NewFiltersParams/NewSearchField';
import { NewFilterDrawerMovements } from 'components/filters/NewFiltersParams/NewFilterDrawerMovements';

import { MovementsFiltersDrawer } from './components';
import { useMovementsMobileState } from '../../hooks/useMovementsMobileState';

export function MovementsMobileSubHeader() {
  const { hasFilters } = useFilterParams();
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const { filterCount } = useDrawerFilter();
  const { movementsMobileState } = useMovementsMobileState();
  const { data: dataMobile, isLoading, isError } = movementsMobileState;

  const resultLength = dataMobile?.pages[0].movements?.length;
  const isEmpty = resultLength === 0 && !hasFilters;
  const isEmptyAndNoFilter = isEmpty && !hasFilters;
  const isInitialLoading = isLoading && !hasFilters;

  if (isInitialLoading || isError || isEmptyAndNoFilter) return null;

  const isDataUnavailable = isEmpty;
  const filterDisabled = !filterCount && isDataUnavailable;

  const handleToggleDrawer = () => {
    setVisibleDrawer(!visibleDrawer);
  };

  return (
    <SubHeader>
      <Grid container spacing={2}>
        <Grid item display={'flex'} gap={'16px'} width={'100%'}>
          <Stack flexGrow={1}>
            <NewSearchField
              name="search"
              currentResultLength={resultLength}
              placeholder="Buscar ID solicitação, nome ou CPF do beneficiário"
            />
          </Stack>
          <NewFilterDrawerMovements
            subtitle="Selecione como deseja filtrar suas movimentações"
            title="Filtrar movimentações"
            disabled={filterDisabled}
          />
        </Grid>
      </Grid>
      <MovementsFiltersDrawer
        toggleDrawer={handleToggleDrawer}
        visibleDrawer={visibleDrawer}
      />
    </SubHeader>
  );
}
